export enum OpsExceptionState {
  PENDING,
  CLEARED,
  RESOLVED,
}

export namespace OpsExceptionState {
  let elements = [OpsExceptionState.PENDING, OpsExceptionState.CLEARED, OpsExceptionState.RESOLVED];
  let alias = "com.bcdfx.model.OpsExceptionState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
